/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';

import store from './store';

import AppWrapper from '@/components/AppWrapper';

import Agreements from '@/routes/Agreements';
import EngineeringActionRequests from '@/routes/EngineeringActionRequests';
import Canals from '@/routes/Canals';
import DevutilReviews from '@/routes/DevutilReviews';
import Home from '@/routes/Home';
import Jobs from '@/routes/Jobs';
import Login from '@/routes/Login';
// import MapView from '@/routes/Map'; // rename to not overwrite es6 Map object
import NotFound from '@/routes/NotFound';
import Parcels from '@/routes/Parcels';
import Permits from '@/routes/Permits';
import Reports from '@/routes/Reports';
import Users from '@/routes/Users';
// import test from '@/routes/test';
import { GetUser } from './lib/db/auth';

Vue.use( Router );

const router = new Router( {
	mode   : 'history',
	base   : process.env.BASE_URL,
	routes : [
		{
			path      : '/login',
			name      : 'login',
			component : Login,
			props     : {}
		},
		{
			path     : '/',
			name     : 'redirect-home',
			redirect : '/app/home',
		},
		{
			path      : '/app',
			name      : 'app',
			component : AppWrapper,
			props     : {},
			redirect  : '/app/home',
			children  : [
				{
					path      : 'home',
					name      : 'home',
					component : Home,
					props     : {}
				},
				{
					path      : 'users',
					name      : 'users',
					component : Users,
					props     : {}
				},
				{
					path      : 'reports',
					name      : 'reports',
					component : Reports,
					props     : {}
				},
				// {
				// 	path      : 'map',
				// 	name      : 'map',
				// 	component : MapView,
				// 	props     : {}
				// },
				{
					path      : 'jobs',
					name      : 'jobs',
					component : Jobs,
					props     : {}
				},
				{
					path      : 'canals',
					name      : 'canals',
					component : Canals,
					props     : {}
				},
				{
					path      : 'agreements',
					name      : 'agreements',
					component : Agreements,
					props     : {}
				},
				{
					path      : 'developer-utility-reviews',
					name      : 'developer-utility-reviews',
					component : DevutilReviews,
					props     : {}
				},
				{
					path      : 'permits',
					name      : 'permits',
					component : Permits,
					props     : {}
				},
				{
					path      : 'engineering-action-requests',
					name      : 'engineering-action-requests',
					component : EngineeringActionRequests,
					props     : {}
				},
				{
					path      : 'parcels',
					name      : 'parcels',
					component : Parcels,
					props     : {}
				},
				// {
				// 	path      : 'test',
				// 	name      : 'test',
				// 	component : test,
				// 	props     : {}
				// }
			]
		},
		{
			path      : '*',
			name      : 'not-found',
			component : NotFound,
			props     : {}
		}
	],
} );

router.beforeEach( ( to, from, next ) => {
	const { postgresUser } = store.getters;
	if ( from.name === 'login' || !postgresUser ) {
		next();
		return;
	}
	if ( to.name !== 'login' && !postgresUser.usersKey ) {
		// console.log( '!postgresUser!' );
		// console.log( postgresUser );
		next( { name : 'login' } );
	} else {
		// console.log( 'postgresUser' );
		// console.log( postgresUser );
		next();
	}
} );

export default router;
